'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTargetedMessageThreads = undefined;

var _reselect = require('reselect');

var _getMessageId = require('../../selectors/widgetDataSelectors/getMessageId');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getThreads = require('./getThreads');

var getTargetedMessageThreads = exports.getTargetedMessageThreads = (0, _reselect.createSelector)([_getThreads.getThreads, _getMessageId.getMessageId], function (threads, welcomeMessageId) {
  if (!threads) return undefined;

  return threads.filter(function (thread) {
    var isSameTargetedMessage = (0, _threadGetters.getWelcomeMessageId)(thread) === welcomeMessageId;
    var hasLatestMessage = !!(0, _threadGetters.getLatestMessage)(thread);

    return isSameTargetedMessage && hasLatestMessage;
  });
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/getTargetedMessageThreads.js
// module id = 969
// module chunks = 2 3